define([
	'components/utilities/utilities',
	'components/cookie/cookie'
], function (utils, cookie) {
	'use strict';

	/**
	 * AcceptCookies
	 * A plugin that adds accept cookie functionality..
	 * @exports acceptCookies
	 */
	var acceptCookies = {

		/**
		 * The initialization function for this module.
		 * @public
		 */
		init: function () {
			this._initEvents();
		},


		/**
		 * Initiates events.
		 * @private
		 */
		_initEvents: function () {
			var els = document.querySelectorAll('[data-type="accept-cookie"]');

			if (els.length > 0) {
				utils.forEach(els, function (el) {
					utils.addEventListener(el, 'click', function (event) {
						if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }

						var target = document.getElementById(el.getAttribute('aria-controls')),
							cookieName = el.getAttribute('data-cookiename');

						cookie.setCookie(cookieName, true, 3650, '/');

						if (target !== null) {
							utils.addClass(target, 'is-animated');

							setTimeout(function () {
								utils.remove(target);
							}, 500);
						}
					});
				});
			}
		}
	};


	return acceptCookies;
});



//////////////////
// WEBPACK FOOTER
// ./components/acceptCookies/acceptCookies.js
// module id = 10
// module chunks = 0